import {
  STATIC_CONTENT_REQUEST,
  STATIC_CONTENT_SUCCESS,
  STATIC_CONTENT_FAILURE,
  BACKGROUNDS_REQUEST,
  BACKGROUNDS_SUCCESS,
  BACKGROUNDS_FAILURE,
  NAMES_REQUEST,
  NAMES_SUCCESS,
  NAMES_FAILURE,
  TEXTS_REQUEST,
  TEXTS_SUCCESS,
  TEXTS_FAILURE, 
  TEXT_REQUEST,
  TEXT_SUCCESS,
  TEXT_FAILURE   
} from '../actions/ContentActions'

export function staticContent(state = {
  data: [],
  errorMesage: ''
}, action) {
  switch(action.type) {
    case STATIC_CONTENT_REQUEST:
      return {
        ...state
      }
    case STATIC_CONTENT_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case STATIC_CONTENT_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    default:
      return state     
  }
}

export function backgrounds(state = {
  data: [],
  errorMesage: ''
}, action) {
  switch(action.type) {
    case BACKGROUNDS_REQUEST:
      return {
        ...state
      }
    case BACKGROUNDS_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case BACKGROUNDS_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    default:
      return state     
  }
}

export function names(state = {
  data: [],
  errorMesage: ''
}, action) {
  switch(action.type) {
    case NAMES_REQUEST:
      return {
        ...state
      }
    case NAMES_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case NAMES_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    default:
      return state     
  }
}

export function texts(state = {
  data: [],
  errorMesage: ''
}, action) {
  switch(action.type) {
    case TEXTS_REQUEST:
      return {
        ...state
      }
    case TEXTS_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case TEXTS_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    default:
      return state     
  }
}

export function text(state = {
  data: {},
  errorMesage: ''
}, action) {
  switch(action.type) {
    case TEXT_REQUEST:
      return {
        ...state
      }
    case TEXT_SUCCESS:
      return {
        ...state,
        data: action.data
      }
    case TEXT_FAILURE:
      return {
        ...state,
        errorMessage: action.error
      }
    default:
      return state     
  }
}


// WEBPACK FOOTER //
// ./src/reducers/ContentReducer.js